import { z as zod } from 'zod'

const schema = zod.object({
  VITE_API_BASE_URL: zod.string().url(),
  VITE_DEFAULT_USERNAME: zod.string().email(),
  VITE_DEFAULT_PASSWORD: zod.string(),
  VITE_NODE_ENV: zod.enum(['development', 'staging', 'production']),
})

export const ENV = schema.parse(import.meta.env)
